import { render, staticRenderFns } from "./MergeFields.vue?vue&type=template&id=565cda77&scoped=true"
import script from "./MergeFields.vue?vue&type=script&lang=js"
export * from "./MergeFields.vue?vue&type=script&lang=js"
import style0 from "./MergeFields.vue?vue&type=style&index=0&id=565cda77&prod&lang=scss"
import style1 from "./MergeFields.vue?vue&type=style&index=1&id=565cda77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cda77",
  null
  
)

export default component.exports